import { Validator } from "devextreme-react";
import HtmlEditor, { Toolbar, Item, MediaResizing, TableContextMenu, ImageUpload } from "devextreme-react/html-editor";
import { CustomRule, RequiredRule } from "devextreme-react/validator";
import styled from "styled-components";

const DescrEditorWrapper = styled.div`
  .dx-htmleditor.dx-htmleditor-outlined.dx-state-focused {
    box-shadow: inset 0 0 0 1px #007048;
    border-color: #007048;
  }

  .dx-variable.quote-box {
    color: black;
    padding: 0;
    background-color: #fafafa;
    > span {
      display: flex;
      background-color: inherit;
      padding: 0;
      border-top-left-radius: 50px;
      border-bottom-left-radius: 50px;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 8px;
        object-fit: contain;
        object-position: center;
        background-color: white;
      }
      .quote-box__description {
        display: flex;
        flex-direction: column;
        justify-content: center;
        > span:first-child {
          font-weight: bold;
        }
      }
    }
  }

  .ql-editor.dx-htmleditor-content {
    img {
      max-width: 800px;
    }
  }
`;

const DescrEditor = (props) => {
  const { cmtRef, defaultValue, SEQ } = props;

  const onInitialized = (e) => {
    const htmlEditor = e.component;
    const Variable = htmlEditor.get("formats/variable");
    class QuoteBox extends Variable {
      static create(value) {
        const node = super.create(value);
        node.setAttribute("class", "dx-variable quote-box");
        node.setAttribute("data-id", `${value.value}`);
        node.innerText = "";
        const [author, desc] = value.escapeChar;
        const [au, auName] = author.split(",");
        const img = document.createElement("img");
        img.setAttribute("src", `${process.env.REACT_APP_BECCO_API_URL}/api/employee/image/${au}`);
        img.setAttribute("alt", `profile of ${au}`);
        const box = document.createElement("span");
        box.setAttribute("class", "quote-box__description");
        const name = document.createElement("span");
        name.innerText = auName;
        const descr = document.createElement("span");
        descr.innerText = desc;
        box.appendChild(name);
        box.appendChild(descr);
        node.appendChild(img);
        node.appendChild(box);
        return node;
      }
    }

    htmlEditor.register({
      "formats/variable": QuoteBox,
    });
  };

  const handleValidateValue = (e) => {
    if (e.value === defaultValue) return false;
    return true;
  };

  const sizeValues = ["8pt", "10pt", "12pt", "14pt", "16pt", "18pt", "20pt", "24pt", "36pt"];
  const fontValues = ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"];

  return (
    <DescrEditorWrapper>
      <HtmlEditor
        defaultValue={defaultValue}
        id={SEQ ? `msg${SEQ}Editor` : "cmtEditor"}
        onInitialized={onInitialized}
        ref={cmtRef}
        width={"100%"}
        height={"100%"}
      >
        <Toolbar multiline={true}>
          <Item name="undo" />
          <Item name="redo" />
          <Item name="separator" />
          <Item name="size" acceptedValues={sizeValues} />
          <Item name="font" acceptedValues={fontValues} />
          <Item name="separator" />
          <Item name="bold" />
          <Item name="italic" />
          <Item name="strike" />
          <Item name="underline" />
          <Item name="separator" />
          <Item name="alignLeft" />
          <Item name="alignCenter" />
          <Item name="alignRight" />
          <Item name="alignJustify" />
          <Item name="separator" />
          <Item name="orderedList" />
          <Item name="bulletList" />
          <Item name="separator" />
          <Item name="separator" />
          <Item name="color" />
          <Item name="background" />
          <Item name="separator" />
          <Item name="link" />
          <Item name="image" />
          <Item name="separator" />
          <Item name="clear" />
          <Item name="codeBlock" />
          <Item name="blockquote" />
          <Item name="separator" />
          <Item name="insertTable" />
          <Item name="deleteTable" />
          <Item name="insertRowAbove" />
          <Item name="insertRowBelow" />
          <Item name="deleteRow" />
          <Item name="insertColumnLeft" />
          <Item name="insertColumnRight" />
          <Item name="deleteColumn" />
        </Toolbar>
        <ImageUpload tabs={["url", "file"]} fileUploadMode={"base64"} />
        <MediaResizing enabled={true} />
        <TableContextMenu enabled={true} />
        <Validator width={"100%"}>
          <RequiredRule message="내용은 필수항목입니다" />
          <CustomRule
            ignoreEmptyValue={true}
            message={"기존 내용에서 수정해주세요"}
            validationCallback={handleValidateValue}
          />
        </Validator>
      </HtmlEditor>
    </DescrEditorWrapper>
  );
};

export default DescrEditor;
